'use strict';

angular.module('shiftTraderApp')
  .factory('Positions', function (ServerUrls, $q, $http, Session) {
    var path = ServerUrls.current.railsApi + 'positions/';

    var Position = function(initData) {
      var p = {};
      angular.extend(p, initData);
      p.default_hourly_wage = Number(initData.default_hourly_wage).toFixed(2);

      p.$update = function(data) {
        var that = this;
        return $http.put(path + this.id, _.assign({organization_id: this.organization_id}, data))
          .then(function(response) {
            that.name = response.data.name;
            that.default_hourly_wage = response.data.default_hourly_wage;
            that.department_id = response.data.department_id;
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      p.$makeInactive = function() {
        var that = this;
        return this.$update({active: false})
          .then(function(response) {
            that.active = response.data.active;
            return response;
          }, function(response) {
            return $q.reject(response);
          });
      };

      p.$makeActive = function() {
        var that = this;
        return this.$update({active: true})
          .then(function(response) {
            that.active = response.data.active;
            return response;
          }, function(response) {
            return $q.reject(response);
          });
      };

      p.toggleCollapsedProperty = function() {
        if (!_.has(p, '_collapsed')) {
          p._collapsed = false;
        } else {
          p._collapsed = !p._collapsed;
        }
      };

      return p;
    };

    var Positions = {};

    Positions.getAllInOrg = function (data) {
      var orgId = Session.getCurrentOrgId();

      var config = {
        params: {
          organization_id: orgId
        }
      };

      if (data) {
        _.extend(config.params, data);
      }

      return $http.get(path, config)
        .then(function (response) {
          return _.map(response.data, function(d) {
            return new Position(d);
          });
        }, function(response) {
          console.log('position getAllInOrg failed');
          return $q.reject(response);
        });
    };

    Positions.bulkUpdate = function(organization_id, positions) {
      return $http.put(path + 'bulk', {
        organization_id: organization_id,
        all_positions: positions
      })
        .then(function(response) {
          return _.map(response.data, function(datum) {
            return new Position(datum);
          });
        }, function(response) {
          console.log('department bulk update failed');
          return $q.reject(response);
        });
    };

    Positions.create = function (attributes) {
      return $http.post(path, {'position': attributes})
        .then(function (response) {
          return new Position(response.data);
        }, function(response) {
          console.log('position created failed');
          return $q.reject(response);
        });
    };

    Positions.initWithData = function(data) {
      return new Position(data);
    };

    return Positions;

  });
